module.exports = __webpack_public_path__ + "img/4.627c367.jpg";